import { newToolFilterOAuthMcp } from "../oauth.ts";

export const cloudinaryMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cloudinary-res.cloudinary.com/image/upload/website/cloudinary_web_favicon.png",
  // Cloudinary has deprecated this server's `/sse` endpoint in favor of
  // `/mcp`.
  url: "https://asset-management.mcp.cloudinary.com/mcp",
  label: "Cloudinary",
});
